"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerDetailsContact = _interopRequireDefault(require("../../styles/dealer-details-contact.css"));
var DealerWebsite = function DealerWebsite(_ref) {
  var website = _ref.website,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: _dealerDetailsContact["default"].dealerDetailLink + " " + (theme ? theme.textLinkPrimary : '') + " " + (theme ? theme.smallType : ''),
    href: "" + website,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='24' height='24' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cpath fill='%23000' id='a' d='M4.003 4v10.764L1.385 20h21.236l-2.618-5.236V4h-16zm2 10h12.001V6H6.003v8zm-.382 2.001h12.764l1 1.999H4.621l1-1.999z'/%3E%3C/defs%3E%3Cuse fill-rule='evenodd' xlink:href='%23a'/%3E%3C/svg%3E",
    alt: "computer icon",
    className: _dealerDetailsContact["default"].contactIcon
  }), website);
};
var _default = DealerWebsite;
exports["default"] = _default;